import { axiosInstance } from "../axiosUtil";

import MetadataJSONStorageStatus from "../../utils/enums/MetadataJSONStorageStatus";
import MetadataStatus from "../../utils/enums/MetadataStatus";
import getAuthHeader from "../Auth/GetAuthHeader";

class MetadataService {
  getMetadataInfo(accountIds) {
    const headers = {
      Authorization: getAuthHeader(),
    };
    const queryParams = "account_id=" + accountIds.join("&account_id=");
    if (Array.isArray(accountIds) && accountIds.length > 0) {
      return axiosInstance
        .get(`api/v1/account/metadata/info?${queryParams}`, { headers })
        .then((response) => {
          return response.data;
        });
    }

    return Promise.reject();
  }

  getMetadataShallow(
    accountId,
    url = "",
    search_field = "",
    search_param = "",
    status_filter = ""
  ) {
    const statusFilterMap = {
      1: MetadataStatus.DRAFT,
      2: MetadataStatus.PENDING_VOICE_TALENT,
      3: MetadataStatus.READY_FOR_REVIEW,
      4: MetadataStatus.IN_PUBLISH_QUEUE,
      5: MetadataStatus.PUBLISHED,
      6: MetadataStatus.ARCHIVED,
    };

    if (!url) {
      url = `/api/v1/account/${accountId}/metadata/view`;
      if (search_param || status_filter) {
        url += "?";
        if (search_param)
          url += `search_field=${search_field}&search_param=${search_param}`;
        if (status_filter)
          url +=
            (search_param ? "&" : "") +
            `status=${statusFilterMap[status_filter]}`;
      }
    }

    const headers = {
      Authorization: getAuthHeader(),
    };

    return axiosInstance.get(url, { headers }).then((response) => {
      return response.data;
    });
  }

  getMetadata(accountId, client_department_id) {
    const url = `/api/v1/account/${accountId}/metadata/view?client_department_id=${client_department_id}`;

    const headers = {
      Authorization: getAuthHeader(),
    };

    return axiosInstance.get(url, { headers }).then((response) => {
      return response.data.results[0];
    });
  }

  async archive(metadata) {
    const payload = { ...metadata };
    payload.archived = true;
    payload.data = {};

    const url = `/api/v1/account/${metadata.account_id}/metadata/update/${metadata.client_department_id}`;
    return axiosInstance
      .put(url, payload, {
        headers: {
          Authorization: getAuthHeader(),
        },
      })
      .then((response) => {
        let data = response.data;
        data.data = squashMetadataData(data);
        return data;
      });
  }

  async restore(metadata) {
    const payload = { ...metadata };
    payload.archived = false;
    payload.data = {};

    const url = `/api/v1/account/${metadata.account_id}/metadata/update/${metadata.client_department_id}`;
    return axiosInstance
      .put(url, payload, {
        headers: {
          Authorization: getAuthHeader(),
        },
      })
      .then((response) => {
        let data = response.data;
        data.data = squashMetadataData(data);
        return data;
      });
  }

  addOrUpdateMetadata(
    accountId,
    client_department_id,
    new_department_id,
    data,
    pronunciations,
    is_virtual,
    saveAsDraft = false,
    settings,
    isNew
  ) {
    const headers = {
      Authorization: getAuthHeader(),
    };
    const url = isNew
      ? `/api/v1/account/${accountId}/metadata/create`
      : `/api/v1/account/${accountId}/metadata/update/${client_department_id}`;
    const method = isNew ? axiosInstance.post : axiosInstance.put;

    const request = {
      client_department_id: new_department_id,
      data,
      pronunciations,
      is_virtual,
      save_as_draft: saveAsDraft,
      priority: settings.priority,
      requested_publish_date: settings.publishDate,
    };

    return method(url, request, {
      headers,
    }).then((response) => {
      let data = response.data;
      data.data = squashMetadataData(data);
      return data;
    });
  }
}

const squashMetadataData = ({ data }) => {
  return (
    data[MetadataJSONStorageStatus.DRAFT] ||
    data[MetadataJSONStorageStatus.PENDING] ||
    data[MetadataJSONStorageStatus.PUBLISHED] ||
    data
  );
};

export default new MetadataService();
